import {   
    Component,
  } from '@angular/core';
  
  @Component({
    selector: 'pm-context-menu-header',
    //templateUrl: './app/controls/components/context-menu/context-menu-header.html',    
    templateUrl: './context-menu-header.html'
  })
  export class ContextMenuHeaderComponent {
  }


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/source/app/controls/components/context-menu/context-menu-header-component.ts